<ion-header>
  <ion-toolbar color="primary">
    <!-- <ion-icon slot="start" size="large" class="header-icon" [src]="TP_SECTIONS_INFO['icd9'].icon | getIcon"></ion-icon> -->
    <ion-title class="header-title">{{ data?.message }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">Chiudi</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="content-container">

  <!-- ============================
     LISTA PAZIENTI
============================= -->
  <!-- Usa le flags esposte dal component per decidere cosa mostrare -->
  <ng-container *ngIf="hasMatchingPatients; else noMatchInstruction">
    <!-- Mostriamo le liste solo se ci sono pazienti corrispondenti -->
    <ng-container *ngIf="patients?.length > 0; else noMatchInstruction">
      <ion-list *ngIf="patients.length > 1; else singleOrNonePatient" lines="none"
                [class.scrollable-list]="patients.length >= 10">
        <div class="section-title">👤 Seleziona il paziente:</div>
        <ion-radio-group [(ngModel)]="selectedPatient" (ionChange)="onSelectionChange($event)"
                         aria-label="Seleziona paziente">
          <ion-list lines="none">
            <ion-item *ngFor="let patient of patients">
              <ion-radio slot="start" [value]="patient"></ion-radio>
              <ion-label class="patient-label">
                <div class="name">{{ patient.surname }} {{ patient.name }}</div>
                <div class="details">
                  <div class="field"><strong>CF:</strong> {{ patient.fiscalCode }}</div>
                  <div class="field"><strong>Nascita:</strong> {{ patient.birthday | date:'dd/MM/yyyy' }}</div>
                  <div class="field"><strong>Email:</strong> {{ patient.email }}</div>
                </div>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-radio-group>
      </ion-list>

      <!-- singolo paziente -->
      <ng-template #singleOrNonePatient>
        <ion-list *ngIf="patients.length === 1; else noMatchPatients" lines="none" class="single-choice-list">
          <ion-item *ngFor="let patient of patients" class="disabled-item">
            <ion-label class="patient-label">
              <div class="name">{{ patient.surname }} {{ patient.name }}</div>
              <div class="details">
                <div class="field"><strong>CF:</strong> {{ patient.fiscalCode }}</div>
                <div class="field"><strong>Nascita:</strong> {{ patient.birthday | date:'dd/MM/yyyy' }}</div>
                <div class="field"><strong>Email:</strong> {{ patient.email }}</div>
              </div>
            </ion-label>
          </ion-item>
        </ion-list>
      </ng-template>

      <!-- Template Nessuna corrispondenza pazienti -->
      <ng-template #noMatchPatients>
        <div class="assistant-text-container no-match">
          <div class="section-title">👤 Paziente:</div>
          <p class="section-title">❌ Nessuna corrispondenza trovata per il paziente menzionato.</p>
        </div>
      </ng-template>

      <!-- ============================
         LISTA FARMACI (mostrata solo se ci sono pazienti)
  ============================= -->
      <ng-container *ngIf="data?.assistantResponse?.content?.drugs as drugs">
        <ion-list *ngIf="drugs.length > 1; else singleOrNoneDrug" lines="none"
                  [class.scrollable-list]="drugs.length >= 10">
          <div class="section-title">💊 Seleziona il farmaco dalla lista:</div>
          <ion-radio-group [(ngModel)]="selectedDrug">
            <ion-item *ngFor="let drug of drugs">
              <ion-radio slot="start" [value]="drug"></ion-radio>
              <ion-label class="patient-label">
                <div class="drugsName">{{ drug.name }}</div>
              </ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-list>
        <!-- singolo farmaco -->
        <ng-template #singleOrNoneDrug>
          <ion-list *ngIf="drugs.length === 1; else noMatchDrug" lines="none" class="single-choice-list">
            <div class="section-title">💊 Farmaco:</div>
            <ion-item *ngFor="let drug of drugs" class="disabled-item">
              <ion-label class="patient-label disabled-label">
                <div class="drugsName">{{ drug.name }}</div>
              </ion-label>
            </ion-item>
          </ion-list>
        </ng-template>
      </ng-container>

    </ng-container>
  </ng-container>

  <!-- Template Nessuna corrispondenza farmaco -->
  <ng-template #noMatchDrug>
    <div class="assistant-text-container no-match">
      <div class="section-title">💊 Farmaco:</div>
      <p class="section-title">❌ Nessuna corrispondenza trovata per il farmaco prescritto.</p>
    </div>
  </ng-template>

  <!-- Template Nessuna corrispondenza istruzione -->
  <ng-template #noMatchInstruction>
    <div class="assistant-text-container no-match">
      <div class="section-title">⚠️ Analisi vocale completata</div>
      <p class="section-title">🤖 Non é stata trovata un’azione corrispondente al comando
        ricevuto.</p>
    </div>
  </ng-template>
</div>

<ion-footer *ngIf="hasMatchingPatients">
  <ion-toolbar> <ion-buttons slot="end">
      <ion-button color="medium" (click)="onCancel()">Annulla</ion-button>
      <ion-button color="primary" [disabled]="!isConfirmEnabled" (click)="onConfirm()">
        Conferma
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>